import { useState } from "react";
import { MagnifyingGlass, CheckCircle, XCircle, Clock, Warning } from "@phosphor-icons/react";
import { api, inr } from "@/lib/api";
import { CONTACT } from "@/data/site";

const STATUS_UI = {
  success: { label: "Confirmed — Advance Paid", cls: "bg-green-100 text-green-700", Icon: CheckCircle },
  failed: { label: "Payment Failed", cls: "bg-red-100 text-red-600", Icon: XCircle },
  flagged: { label: "Under Verification", cls: "bg-amber-100 text-amber-700", Icon: Warning },
  initiated: { label: "Payment Pending", cls: "bg-gray-200 text-gray-600", Icon: Clock },
};

export default function TrackBooking() {
  const [q, setQ] = useState("");
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const search = async (e) => {
    e.preventDefault();
    if (q.trim().length < 5) { setError("Poora phone number ya transaction ID daalein"); return; }
    setLoading(true);
    setError("");
    try {
      const r = await api.get("/payments/track", { params: { query: q } });
      setResults(r.data);
    } catch {
      setError("Kuch galat ho gaya — dobara try karein.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="track-booking-page">
      <section className="relative bg-brand-navy py-16 overflow-hidden grain">
        <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-10 text-center">
          <h1 className="text-4xl sm:text-6xl font-heading font-semibold text-white">Track Your Booking</h1>
          <p className="mt-3 text-white/75 font-body">Phone number ya Transaction ID se apni booking ka status dekhein</p>
        </div>
      </section>

      <section className="max-w-2xl mx-auto px-5 py-14">
        <form onSubmit={search} className="flex flex-col sm:flex-row gap-3">
          <div className="relative flex-1">
            <MagnifyingGlass size={20} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#a3a1ba]" />
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              data-testid="track-input"
              placeholder="Phone number ya Transaction ID"
              className="w-full rounded-full border border-brand-sand bg-white pl-11 pr-4 py-3.5 text-sm outline-none focus:border-brand-teal focus:ring-2 focus:ring-brand-teal/30"
            />
          </div>
          <button type="submit" disabled={loading} data-testid="track-submit"
            className="rounded-full bg-brand-orange px-8 py-3.5 text-sm font-bold uppercase tracking-wide text-white transition-transform hover:-translate-y-0.5 disabled:opacity-60">
            {loading ? "Searching..." : "Track"}
          </button>
        </form>
        {error && <p className="mt-3 text-sm text-red-500 text-center" data-testid="track-error">{error}</p>}

        {results !== null && (
          <div className="mt-8 space-y-4" data-testid="track-results">
            {results.length === 0 ? (
              <div className="rounded-2xl bg-white p-8 text-center shadow-[0_8px_30px_rgba(46,42,128,0.08)]" data-testid="track-empty">
                <p className="text-[#6b6a8a]">Koi booking nahi mili is detail se.</p>
                <p className="mt-2 text-sm text-[#8B89A4]">Wahi phone number use karein jo payment ke waqt diya tha, ya call karein {CONTACT.phones[0]}</p>
              </div>
            ) : (
              results.map((b) => {
                const ui = STATUS_UI[b.status] || STATUS_UI.initiated;
                return (
                  <div key={b.txnid} className="rounded-2xl bg-white p-6 shadow-[0_8px_30px_rgba(46,42,128,0.10)]" data-testid={`track-result-${b.txnid}`}>
                    <div className="flex flex-wrap items-start justify-between gap-3">
                      <div>
                        <p className="font-heading text-xl font-semibold text-brand-navy">{b.package_title}</p>
                        <p className="mt-0.5 text-sm text-[#8B89A4]">{b.name} · {new Date(b.created_at).toLocaleDateString("en-IN")}</p>
                      </div>
                      <span className={`inline-flex items-center gap-1.5 rounded-full px-4 py-1.5 text-xs font-bold ${ui.cls}`}>
                        <ui.Icon size={15} weight="fill" /> {ui.label}
                      </span>
                    </div>
                    <div className="mt-4 grid grid-cols-2 sm:grid-cols-4 gap-3 text-sm">
                      <div><p className="text-[11px] uppercase text-[#8B89A4]">Paid</p><p className="font-bold text-brand-orange">{inr(b.amount)}</p></div>
                      {b.advance_percent < 100 && <div><p className="text-[11px] uppercase text-[#8B89A4]">Package Price</p><p className="text-brand-navy font-semibold">{inr(b.total_price)}</p></div>}
                      {b.travel_date && <div><p className="text-[11px] uppercase text-[#8B89A4]">Travel Date</p><p className="text-brand-navy font-semibold">{b.travel_date}</p></div>}
                      {b.travelers && <div><p className="text-[11px] uppercase text-[#8B89A4]">Travellers</p><p className="text-brand-navy font-semibold">{b.travelers}</p></div>}
                    </div>
                    <p className="mt-3 text-[11px] font-mono text-[#a3a1ba]">Txn: {b.txnid}</p>
                  </div>
                );
              })
            )}
          </div>
        )}
      </section>
    </div>
  );
}
